module.exports = __webpack_public_path__ + "static/media/ico_logout_active.24bac73c.svg";